
export const relatedList = [
  {
    thumb: "//cdn.nuevodevel.com/media/surf_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/surf",
    title: "Surfing is beatiful",
    duration: "04:12"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/big_buck_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/big_buck",
    title: "Big Buck Bunny",
    duration: "02:17"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/animals_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/animals",
    title: "Animals are amazing!",
    duration: "03:03"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/freeride_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/freeride",
    title: "Free Ride",
    duration: "05:50"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/australia_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/australia",
    title: "Welcome to Australia",
    duration: "02:29"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/fit_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/fit",
    title: "Fitness keeps you younger and healthy",
    duration: "01:33"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/alaska_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/alaska",
    title: "The beauty of Alasca",
    duration: "02:54"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/cymaticjazz_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/cymaticjazz",
    title: "LG Cymatic Jazz Demo",
    duration: "02:35"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/serenity_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/serenity",
    title: "Serenity Movie Trailer",
    duration: "02:13"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/newyorkcity_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/newyorkcity",
    title: "New York City 4K",
    duration: "01:07"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/thailand_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/thailand",
    title: "Thailand Retrospective",
    duration: "02:06"
  },
  {
    thumb: "//cdn.nuevodevel.com/media/people_thumb.jpg",
    url: "//www.nuevodevel.com/nuevo/demo/people",
    title: "People activity grows",
    duration: "01:13"
  }
];